import { Box, CheckBox, TextNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'

interface propTypes {
  checkboxText?: string
  textLabel?: string
  fieldName: string
  setFieldValue: (fieldName: string, val: boolean | number) => void
  value?: undefined | boolean
}

export const checkboxWithLeftHeader = (props: propTypes) => {
  const textLabel = props?.textLabel
  const checkboxText = props?.checkboxText
  const checked = props?.value
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isChecked, updateChecked] = useState(false)
  const fieldName = props?.fieldName
  const setFieldValue = props?.setFieldValue

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (checked) {
      updateChecked(checked)
    }
  }, [checked])

  return (
    <Box flexDirection="row" pl={'6%'}>
      {textLabel && (
        <Box>
          <TextNew type="body12" color="BLACK_21" fontWeight="bold">
            {textLabel}
          </TextNew>
        </Box>
      )}
      <Box flexDirection="row" borderColor="YELLOW" pl={textLabel ? 130 : 190}>
        <CheckBox
          textStyle="body2"
          textColor="LIGHT_BLACK"
          onChange={() => [setFieldValue(fieldName, !isChecked), updateChecked(!isChecked)]}
          iconSize="LARGE"
          fontWeight="MEDIUM"
          checked={isChecked}
          textLabel={checkboxText}
          color={'BLUE'}
        />
      </Box>
    </Box>
  )
}
